<template>
  <div>
    <div class="post-section blog-v3 load-more-contain section-gap mt-3">
      <div class="container">
        <div class="input-group rounded pb-1">
          <input
            type="search"
            class="form-control rounded"
            placeholder="Search"
            aria-label="Search"
            @input="search"
            v-model="Model.keyWord"
            aria-describedby="search-addon"
          />
          <span class="mx-2 mt-1 border-0" id="search-addon">
            <i class="fas fa-search"></i>
          </span>
        </div>
        <div class="row">
          <div
            class="col-sm-12 col-md-6 col-lg-6"
            v-for="(item, index) of News"
            :key="index"
            @click="newsDetails(item)"
          >
            <div class="card border-0 border-rad mb-0 shadow-lg col-lg-12">
              <span
                class="_addtoFav py-2 px-3 position-absolute"
                @click.stop="UpdateStatus(item, index)"
              >
                <i
                  class="fa fa-heart text-white fa-2x"
                  v-if="item.IsFavorite"
                ></i>
                <i class="far fa-heart text-white fa-2x" v-else></i>
              </span>
              <img
                class="border-rad-top img-fluid w-100"
                v-if="item.ImageURL"
                :src="baseURL + item.ImageURL"
                alt="Card image cap"
                width="370"
                height="250"
              />
              <img
                v-else
                src="/static/img/enNotAvail.png"
                alt=""
                height="250"
                class="card-img-top border-bottom"
              />
              <div class="card-body border-rad-bottom">
                <h4 class="card-title mb-2">
                  <a href="/blog-detail">{{ item.Name }}</a>
                </h4>
                <div class="p-0">
                  <div class="d-flex justify-content-between">
                    <a class="d-flex align-content-start text-muted card-text">
                      {{ item.Brief }}
                    </a>

                    <a class="d-flex align-content-end">
                      <i class="fa fa-calendar-o mr-2 align-self-center"></i>
                      <span class="font-sm text-capitalize">{{
                        item.PublishDate | formatDate("yyyy/MM/dd")
                      }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div ref="News"></div>
    </div>
  </div>
</template>

<script>
import { domain } from "@/globalComponents.js";

export default {
  name: "News",
  data() {
    return {
      searchactive: false,
      baseURL: domain,
      News: [],
      Model: {
        title: "",
        brief: "",
        description: "",
        keyWord: "",
        pageNumber: 1,
        isPaging: true,
        pageCount: 20,
      },
      isDone: false,
      isMounted: false,
    };
  },
  methods: {
    newsDetails(item) {
      this.$router.push({ name: "NewsDetails", params: { ID: item.ID } });
    },
    UpdateStatus(item, index) {
      if (this.$store.state.auth.isUserLoggedIn()) {
        let model = {};
        model.newsID = item.ID;
        this.$store
          .dispatch("DataList/ToggleUserFavorite", model)
          .then(() => {
            this.News[index].IsFavorite = !this.News[index].IsFavorite;
          })
          .catch(() => {});
        return false;
      } else {
        this.$toasted.show(this.$t("PleaseLoginFirst"), {
          theme: "outline",
          position: "bottom-center",
          duration: 5000,
        });
        return true;
      }
    },
    onScroll() {
      debugger;
      if (!this.isDone && this.isMounted) {
        var usersHeading = this.$refs["News"];
        if (usersHeading) {
          var marginTopUsers = usersHeading.getBoundingClientRect().top;
          var innerHeight = window.innerHeight;

          if (marginTopUsers - innerHeight < -50) {
            this.loadMore();
          }
        }
      }
    },

    loadMore() {
      this.Model.pageNumber += 1;
      this.$store
        .dispatch("DataList/SearchNewsWithPaging", this.Model)
        .then((response) => {
          if (response.status == 200) {
            debugger;
            if (response.data.data.length > 0) {
              response.data.data.forEach((element) => {
                this.News.push(element);
              });
            } else {
              this.isDone = true;
            }
          }
        })
        .catch(() => {});
    },
    search() {
      this.$store
        .dispatch("DataList/SearchNewsWithPaging", this.Model)
        .then((response) => {
          if (response.status == 200) {
            debugger;
            this.News = response.data.data;
            this.isMounted = true;
          }
        })
        .catch(() => {});
    },
  },
  created() {
    this.search();
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener("scroll", this.onScroll);
      this.onScroll(); // needed for initial loading on page
    });
  },
};
</script>
<style lang="scss">
.PlayIcon {
  top: 45%;
  right: 30px;
  z-index: 500;
}
._cartBtn {
  left: 1.25rem;
}

._addtoFav {
  cursor: pointer;
}
</style>
